import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      filters: state => state.stat.filters
    })
  },

  methods: {
    filterByTags(data, tagFilter) {
      if (!tagFilter.length) return data;

      return data.filter(i => {
        if (i.Stats.Tags) {
          const itemTags = Object.keys(i.Stats.Tags);
          if (itemTags.length) {
            for (let index = 0; index < tagFilter.length; index++) {
              if (itemTags.find(t => t === tagFilter[index].id)) {
                return true;
              }
            }
          }
        }
      });
    },

    filterByProvider(data, providerFilter) {
      if (!providerFilter.length) return data;

      return data.filter(i => {
        if (i.Stats.PartnerNames) {
          const itemPartners = Object.keys(i.Stats.PartnerNames);
          if (itemPartners.length) {
            for (let index = 0; index < providerFilter.length; index++) {
              if (itemPartners.find(t => t === providerFilter[index].PartnerName)) {
                return true;
              }
            }
          }
        }
      });
    }
  }
}
